import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    padding: 10,

    '& p.name': {
      textTransform: 'capitalize',
    },

    '& > p > span': {
      fontWeight: 600,
    },
  },
}))

export default styles
